export enum ImsUpdateState {
    NEW = 'NEW',
    QUEUED = 'QUEUED',
    PROGRESS = 'PROGRESS',
    ERROR = 'ERROR',
    COMPLETED = 'COMPLETED',
    TIMEOUT = 'TIMEOUT',
    UNKNOWN = 'UNKNOWN',
    CANCELLED = 'CANCELLED'
}